import { render, staticRenderFns } from "./onSubFormRowInsert-editor.vue?vue&type=template&id=2af685e7&scoped=true"
import script from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js"
export * from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af685e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af685e7')) {
      api.createRecord('2af685e7', component.options)
    } else {
      api.reload('2af685e7', component.options)
    }
    module.hot.accept("./onSubFormRowInsert-editor.vue?vue&type=template&id=2af685e7&scoped=true", function () {
      api.rerender('2af685e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onSubFormRowInsert-editor.vue"
export default component.exports